var map = {
	"./LeadershipLearnerVoice1.jpg": 1560,
	"./LeadershipLearnerVoice2.jpg": 2487,
	"./LeadershipLearnerVoice3.jpg": 1322,
	"./LeadershipLearnerVoice4.jpg": 7785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9860;